export const messages = {
  placeholder: {
    id: "location-modal.placeholder",
    defaultMessage: "Choose location",
  },
};
